import React, { useState } from 'react';
import './PanelMenu.css';

const hotels = [
  {
    name: 'ORYZA LEISURE',
    url: 'https://oryzalesure.uw.r.appspot.com/oryza/',
    image: '/pettipetti/img/hotelbg/oryzalanding.webp',
  },
  {
    name: 'PETTI PETTI MIRISSA',
    url: 'https://oryzalesure.uw.r.appspot.com/pettipettimirissa',
    image: '/pettipetti/img/hotelbg/pettipetti.webp',
  },
  {
    name: 'KENT COTTAGE NUWARA ELIYA',
    url: 'https://oryzalesure.uw.r.appspot.com/kent/home',
    image: '/pettipetti/img/hotelbg/kent.webp',
  },
  {
    name: 'BANANA BUNKS KANDY',
    url: '/BananaBunksKandy',
    image: '/pettipetti/img/hotelbg/bbkandy.webp',
  },
  {
    name: 'BANANA BUNKS MIRISSA',
    url: 'https://oryzalesure.uw.r.appspot.com/BananaBunksMirissa',
    image: '/pettipetti/img/hotelbg/bbmirissa.webp',
  },
];

const PanelMenu = ({ show }) => {
  const [activeIndex, setActiveIndex] = useState(-1);  // last hovered hotel (background)
  const [hoveredIndex, setHoveredIndex] = useState(-1); // current hovered for dimming

  // When mouse leaves the whole hotel list, remove dimming but keep background image
  const handleMouseLeaveList = () => {
    setHoveredIndex(-1);
  };

  return (
    <div className={`panel_menu ${show ? 'active' : ''}`}>
      <div className="panel__content">
        <div className="panel__content_wrapper">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-lg-9">
                <nav className="wrapper_menu">
                  <ul onMouseLeave={handleMouseLeaveList}>
                    {hotels.map((hotel, index) => (
                      <li key={index}>
                        <div className="container-item upper">
                          <a
                            href={hotel.url}
                            className={`link upper ${
                              hoveredIndex !== -1 && hoveredIndex !== index ? 'dimmed' : ''
                            }`}
                            onMouseEnter={() => {
                              setHoveredIndex(index);
                              setActiveIndex(index);
                            }}
                          >
                            {hotel.name}
                          </a>
                        </div>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
              <div className="col-lg-3 d-flex align-items-end">
                <div className="menu_panel_details">
                  <div className="row justify-content-between">
                    <div className="col-lg-12 mb-lg-0 mb-4">
                      <h5 style={{ color: '#fff',lineHeight : "22px" }}>Contact Us</h5>
                      <div className="contacts">
                        <ul>
                          <li><a href="tel:+94767008800" style={{ color: '#fff' }}>+94 76 700 8800</a></li>
                          <li><a href="mailto:hello@oryzaleisure.com" style={{ color: '#fff' }}>reservations@oryzaleisure.com</a></li>
                        </ul>
                      </div>
                      <div className="social">
                        <ul>
                          <li><a href="https://www.facebook.com/pettipettimirissa"><i className="bi bi-facebook"></i></a></li>
                          <li><a href="https://www.instagram.com/oryzaleisure"><i className="bi bi-instagram"></i></a></li>
                          <li><a href="https://wa.me/94767008800"><i className="bi bi-whatsapp"></i></a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /row */}
          </div>
        </div>

        {/* Background image stack */}
        <div className="background-image-wrapper">
          {hotels.map((hotel, i) => (
            <img
              key={i}
              src={hotel.image}
              alt={hotel.name}
              className={`bg-image ${activeIndex === i ? 'visible' : ''}`}
            />
          ))}
          {/* Default background if no hotel hovered yet */}
          {activeIndex === -1 && (
            <img
              src="/pettipetti/img/hotelbg/oryzalanding.webp"
              alt="Default Background"
              className="bg-image visible"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PanelMenu;
